import React from "react";
import { Routes, Route } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import { NotFound } from "./NotFound";
import { Forbidden } from "./Forbidden";
import { Layout } from "../components/common/Layout";
import { useAuth } from "../hooks/AuthProvider";

export const AppRoutes: React.FC = () => {
  const auth = useAuth();
  return auth.isLoading ? (
    <div
      style={{
        position: "fixed",
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "white",
      }}
    >
      <CircularProgress />
    </div>
  ) : (
    <Routes>
      <Route path="/not-found" element={<NotFound />} />
      <Route path="/forbidden" element={<Forbidden />} />
      {!auth.isLoading && auth.isLoggedIn && <Route path="/*" element={<Layout />} />}
    </Routes>
  );
};
